import { PRIMARY } from "../../theme/palette";
import renter from "../../assets/Logo/renter.png";
import buying from "../../assets/Logo/buying.png";
import purching from "../../assets/Logo/purchase.png";
import refinance from "../../assets/Logo/refinance.png";
import heloc from "../../assets/Logo/heloc.png";
import listing from "../../assets/Logo/listing.png";
import selling from "../../assets/Logo/selling.png";

export const roles = [
  { id: process.env.REACT_APP_ADMINISTRATOR_ID, name: "Administrator" },
  { id: process.env.REACT_APP_GUEST_ID, name: "Guest" },
  // { id: process.env.REACT_APP_EMPLOYEE_ID, name: "Employee" },
];

export const TABS = [
  {
    value: "timeline",
    label: "Timeline",
  },
  {
    value: "tasks",
    label: "Tasks",
  },
  {
    value: "document",
    label: "Documents",
  },
  {
    value: "campaignActivity",
    label: "Campaign Activity",
  },
];

export const leadPhase = [
  {
    value: "Inquiry",
    label: "Inquiry",
  },
  {
    value: "Nurture",
    label: "Nurture",
  },
  {
    value: "Engaged",
    label: "Engaged",
  },
];

export const OpportunityBuyingPhase = [
  {
    value: "BROKER AGREEMENT",
    label: "BROKER AGREEMENT",
  },
  {
    value: "SEARCHING",
    label: "SEARCHING",
  },
  {
    value: "SHOWING",
    label: "SHOWING",
  },
  {
    value: "OFFERING",
    label: "OFFERING",
  },
  {
    value: "NURTURE",
    label: "NURTURE",
  },
];

export const OpportunitySellingPhase = [
  {
    value: "LISTING AGREEMENT",
    label: "LISTING AGREEMENT",
  },
  {
    value: "COMING SOON",
    label: "COMING SOON",
  },
  {
    value: "ON MARKET",
    label: "ON MARKET",
  },
  {
    value: "OFFERS IN",
    label: "OFFERS IN",
  },
  {
    value: "EXPIRED",
    label: "EXPIRED",
  },
  {
    value: "NURTURE",
    label: "NURTURE",
  },
];

export const OpportunityRenterPhase = [
  {
    value: "LISTING AGREEMENT",
    label: "LISTING AGREEMENT",
  },
  {
    value: "COMING SOON",
    label: "COMING SOON",
  },
  {
    value: "ON MARKET",
    label: "ON MARKET",
  },
  {
    value: "OFFERS IN",
    label: "OFFERS IN",
  },
  {
    value: "EXPIRED",
    label: "EXPIRED",
  },
  {
    value: "NURTURE",
    label: "NURTURE",
  },
];

export const TransactionPhase = [
  {
    value: "UNDER CONTRACT",
    label: "UNDER CONTRACT",
  },
  {
    value: "INSPECTION COMPLETE",
    label: "INSPECTION COMPLETE",
  },
  {
    value: "APPRAISAL COMPLETE",
    label: "APPRAISAL COMPLETE",
  },
  {
    value: "CLOSED",
    label: "CLOSED",
  },
  {
    value: "KEYS EXCHANGED",
    label: "KEYS EXCHANGED",
  },
  {
    value: "MUTUALLY RELEASED",
    label: "MUTUALLY RELEASED",
  },
  {
    value: "WITHDRAWN",
    label: "WITHDRAWN",
  },
];

export const TabsOpportunityType = [
  {
    value: "buying",
    label: "Buying",
  },
  {
    value: "selling",
    label: "Selling",
  },
  {
    value: "leaseListing",
    label: "Lease Listing",
  },
  {
    value: "leaseRenter",
    label: "Lease Renter",
  },
];

export const ApplicationInfoTabsPurchaseType = [
  {
    value: "loan-info",
    label: "Loan Info",
  },
  {
    value: "income",
    label: "Income",
  },
  {
    value: "debts",
    label: "Debts",
  },
  {
    value: "assets",
    label: "Assets",
  },
  {
    value: "pre-approval",
    label: "Pre-Approval",
  },
  {
    value: "proposed-loan",
    label: "Proposed Loan",
  },
];

export const LoanSubmissionAccordionTab = [
  {
    value: "loan-summary",
    label: "Loan Summary",
  },
  {
    value: "loan-file",
    label: "Loan File",
  },
  {
    value: "key-dates",
    label: "Key Dates",
  },
  {
    value: "closing-info",
    label: "Closing Info",
  },
  {
    value: "compliance",
    label: "Compliance",
  },
  {
    value: "accounting",
    label: "Accounting",
  },
];

export const ApplicationInfoTabsRefinanceType = [
  {
    value: "refinance-info",
    label: "Refinance Info",
  },
  {
    value: "income",
    label: "Income",
  },
  {
    value: "debts",
    label: "Debts",
  },
  {
    value: "assets",
    label: "Assets",
  },
  {
    value: "current-loan",
    label: "Current Loan",
  },
  {
    value: "proposed-loan",
    label: "Proposed Loan",
  },
];

export const ApplicationInfoTabsHelocType = [
  {
    value: "heloc-info",
    label: "Heloc Info",
  },
  {
    value: "income",
    label: "Income",
  },
  {
    value: "debts",
    label: "Debts",
  },
  {
    value: "assets",
    label: "Assets",
  },
  {
    value: "current-loan",
    label: "Current Loan",
  },
  {
    value: "proposed-loan",
    label: "Proposed Loan",
  },
];

export const TAB_ACTION = [
  {
    value: "addActivity",
    label: "Add Activity",
  },
  {
    value: "sendEmail",
    label: "Send Email",
  },
  {
    value: "sendSMS",
    label: "Send SMS",
  },
  // {
  //   value: "addNote",
  //   label: "Add Note",
  // },
];

export const Lead_Option = [
  { value: "Agent", label: "Agent" },
  { value: "Buyer", label: "Buyer" },
  { value: "Direct mail", label: "Direct mail" },
  { value: "Door knocking", label: "Door knocking" },
];

export const OPTIONS = [
  { value: "Lead", label: "Lead" },
  { value: "Contact", label: "Contact" },
];

export const Option_Opportunity = [
  { value: "Buying", label: "Real Estate Buying" },
  { value: "Selling", label: "Real Estate Selling" },
  { value: "Lease Renter", label: "Real Estate Lease Renter" },
  { value: "Lease Listing", label: "Real Estate Lease Listing" },
  // { value: "Mortgage Purchase", label: "Mortgage Purchase" },
  // { value: "Mortgage Refinance", label: "Mortgage Refinance" },
  // { value: "Mortgage HELOC", label: "Mortgage HELOC" },
];

export const Option_Transaction = [
  { value: "Buying", label: "Transaction Buying" },
  { value: "Selling", label: "Transaction Selling" },
  { value: "Lease Renter", label: "Transaction Lease Renter" },
  { value: "Lease Listing", label: "Transaction Lease Listing" },
];

export const OpportunityBuyingOptions = [
  {
    value: "Ideal Home",
    label: "Ideal Home",
  },
  {
    value: "Financial Information",
    label: "Financial Information",
  },
  {
    value: "Tours Data",
    label: "Tours Data",
  },
  {
    value: "Key Dates",
    label: "Key Dates",
  },
];

export const TransactionBuyingOptions = [
  {
    value: "Transaction",
    label: "Transaction",
  },
  {
    value: "Commission Info",
    label: "Commission Info",
  },
  {
    value: "Loan Information",
    label: "Loan Information",
  },
  {
    value: "Key Dates",
    label: "Key Dates",
  },
  {
    value: "Vendor Info",
    label: "Vendor Info",
  },
  {
    value: "Appliance Information",
    label: "Appliance Information",
  },
];

export const TransactionSellingOptions = [
  {
    value: "Transaction Information",
    label: "Transaction Information",
  },
  {
    value: "Commission",
    label: "Commission",
  },
  {
    value: "Seller Financials",
    label: "Seller Financials",
  },
  {
    value: "Key Dates",
    label: "Key Dates",
  },
  {
    value: "Vendors",
    label: "Vendors",
  },
  {
    value: "Financing Information",
    label: "Financing Information",
  },
];

export const TransactionLeaseRenterOptions = [
  {
    value: "Transaction Information",
    label: "Transaction Information",
  },
  {
    value: "Commissions",
    label: "Commissions",
  },
  {
    value: "Key Dates",
    label: "Key Dates",
  },
  {
    value: "Tours Data",
    label: "Tours Data",
  },
];

export const TransactionLeaseListingOptions = [
  {
    value: "Transaction Information",
    label: "Transaction Information",
  },
  {
    value: "Commission",
    label: "Commission",
  },
  {
    value: "Key Dates",
    label: "Key Dates",
  },
  {
    value: "Lease Information",
    label: "Lease Information",
  },
  // {
  //   value: "Listing Information",
  //   label: "Listing Information",
  // },
  // {
  //   value: "Seller Financials",
  //   label: "Seller Financials",
  // },
  {
    value: "Vendors",
    label: "Vendors",
  },
  {
    value: "Renter Info",
    label: "Renter Info",
  },
];

export const FinancialOptions = [
  {
    value: "CONVENTIONAL",
    label: "CONVENTIONAL",
  },
  {
    value: "FHA",
    label: "FHA",
  },
  {
    value: "VA",
    label: "VA",
  },
  {
    value: "USDA",
    label: "USDA",
  },
  {
    value: "OTHER",
    label: "OTHER",
  },
];

export const FinancingOptions = [
  {
    value: "Financing",
    label: "Financing",
  },
  {
    value: "Cash",
    label: "Cash",
  },
];
export const LoanTermOptions = [
  {
    value: "10 YR",
    label: "10 YR",
  },
  {
    value: "15 YR",
    label: "15 YR",
  },
  {
    value: "20 YR",
    label: "20 YR",
  },
  {
    value: "25 YR",
    label: "25 YR",
  },
  {
    value: "30 YR",
    label: "30 YR",
  },
];

export const DesiredLeaseOptions = [
  {
    value: "6 MO",
    label: "6 MO",
  },
  {
    value: "1 YR",
    label: "1 YR",
  },
  {
    value: "18 MO",
    label: "18 MO",
  },
  {
    value: "2 YR",
    label: "2 YR",
  },
  {
    value: "3 YR",
    label: "3 YR",
  },
  {
    value: "5 YR",
    label: "5 YR",
  },
];

export const TimeFrameOptions = [
  {
    value: "30 Days",
    label: "30 Days",
  },
  {
    value: "90 Days",
    label: "90 Days",
  },
  {
    value: "180 Days",
    label: "180 Days",
  },
  {
    value: "180+ Days",
    label: "180+ Days",
  },
];

export const citiesOptions = [
  {
    value: "New York",
    label: "New York",
    id: "New York",
  },
  {
    value: "London",
    label: "London",
    id: "London",
  },
  {
    value: "Florida",
    label: "Florida",
    id: "Florida",
  },
];

export const OpportunitySellingOptions = [
  {
    value: "Listing Information",
    label: "Listing Information",
  },
  {
    value: "Commission",
    label: "Commission",
  },
  {
    value: "Seller Financials",
    label: "Seller Financials",
  },
  {
    value: "Key Dates",
    label: "Key Dates",
  },
  {
    value: "Vendors",
    label: "Vendors",
  },
  // {
  //   value: "Transaction Information",
  //   label: "Transaction Information",
  // },
];

export const OpportunityLeaseRenterOptions = [
  {
    value: "Lease Information",
    label: "Lease Information",
  },
  {
    value: "Key Dates",
    label: "Key Dates",
  },
  {
    value: "Renter Information",
    label: "Renter Information",
  },
];

export const OpportunityLeaseListingOptions = [
  {
    value: "Listing Information",
    label: "Listing Information",
  },
  {
    value: "COMMISSIONS",
    label: "Commissions",
  },
  {
    value: "Key Dates",
    label: "Key Dates",
  },
  {
    value: "vendors",
    label: "Vendors",
  },
];

export const incomeTypeOptions = [
  {
    value: "Standard",
    label: "Standard",
  },
  {
    value: "Foreign",
    label: "Foreign",
  },
  {
    value: "Seasonal",
    label: "Seasonal",
  },
  {
    value: "Temporary Leave",
    label: "Temporary Leave",
  },
  {
    value: "Self Employed",
    label: "Self Employed",
  },
];

export const assetsTypeOptions = [
  {
    value: "Bank Account",
    label: "Bank Account",
  },
  {
    value: "Stocks and Bonds",
    label: "Stocks and Bonds",
  },
  {
    value: "Life Inusrance",
    label: "Life Inusrance",
  },
  {
    value: "Retirement",
    label: "Retirement",
  },
  {
    value: "Gift",
    label: "Gift",
  },
  {
    value: "Other",
    label: "Other",
  },
];

export const debtTypeOptions = [
  {
    value: "Personal Loan",
    label: "Personal Loan",
  },
  {
    value: "Credit Card",
    label: "Credit Card",
  },
  {
    value: "Home Loan",
    label: "Home Loan",
  },
  {
    value: "Car Loan",
    label: "Car Loan",
  },
  {
    value: "Student Loan",
    label: "Student Loan",
  },
];

export const numberOptions = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" },
  { value: 12, label: "12" },
];

export const numberOptionsBathrooms = [
  { value: 1, label: "1" },
  { value: 1.5, label: "1.5" },
  { value: 2, label: "2" },
  { value: 2.5, label: "2.5" },
  { value: 3, label: "3" },
  { value: 3.5, label: "3.5" },
  { value: 4, label: "4" },
  { value: 4.5, label: "4.5" },
  { value: 5, label: "5" },
  { value: 5.5, label: "5.5" },
  { value: 6, label: "6" },
  { value: 6.5, label: "6.5" },
  { value: 7, label: "7" },
  { value: 7.5, label: "7.5" },
];

export const carOptions = [
  { value: "No", label: "No" },
  { value: "1 Car", label: "1 Car" },
  { value: "2 Car", label: "2 Car" },
  { value: "3 Car", label: "3 Car" },
  { value: "4+ Car", label: "4+ Car" },
];

export const structureOptions = [
  { value: "Slab", label: "Slab" },
  { value: "Crawl", label: "Crawl" },
  { value: "Partially Finished", label: "Partially Finished" },
  { value: "Finished", label: "Finished" },
  { value: "Walkout", label: "Walkout" },
];

export const WaterfrontTypeOptions = [
  { value: "No", label: "No" },
  { value: "Canal", label: "Canal" },
  { value: "Lake Front", label: "Lake Front" },
];

export const inspectionStatus = [
  { value: "Scheduled", label: "Scheduled" },
  { value: "Complete Negotiating", label: "Complete Negotiating" },
  { value: "Complete Repairs", label: "Complete Repairs" },
  { value: "Cleared", label: "Cleared" },
];

export const appraisalStatus = [
  { value: "Ordered", label: "Ordered" },
  { value: "Scheduled", label: "Scheduled" },
  { value: "Repairs Needed", label: "Repairs Needed" },
  { value: "Negotiating", label: "Negotiating" },
  { value: "Cleared", label: "Cleared" },
];

export const loanStatus = [
  { value: "Applied", label: "Applied" },
  { value: "In Underwriting", label: "In Underwriting" },
  { value: "Conditionally Approved", label: "Conditionally Approved" },
  { value: "Initial CD Out", label: "Initial CD Out" },
  { value: "Clear To Close", label: "Clear To Close" },
];

export const LandlordOrTenant = [
  { value: "Landlord", label: "Landlord" },
  { value: "Tenant", label: "Tenant" },
];

export const Preferred_Method = [
  {
    value: "DIAL ATTEMPT",
    label: "DIAL ATTEMPT",
  },
  {
    value: "EMAIL OUT",
    label: "EMAIL OUT",
  },
  {
    value: "PHONE OUT",
    label: "PHONE OUT",
  },
  {
    value: "TEXT OUT",
    label: "TEXT OUT",
  },
  {
    value: "EMAIL IN",
    label: "EMAIL IN",
  },
  {
    value: "PHONE IN",
    label: "PHONE IN",
  },
  {
    value: "TEXT IN",
    label: "TEXT IN",
  },
  {
    value: "MEETING - LIVE",
    label: "MEETING - LIVE",
  },
  {
    value: "MEETING - VIRTUAL",
    label: "MEETING - VIRTUAL",
  },
  {
    value: "Lead: Zillow",
    label: "Lead: Zillow",
  },
  {
    value: "Lead: Sierra Interactive",
    label: "Lead: Sierra Interactive",
  },
];

export const Preferred_Method_Select = [
  {
    value: "DIAL ATTEMPT",
    label: "DIAL ATTEMPT",
    check: true,
  },
  {
    value: "EMAIL OUT",
    label: "EMAIL OUT",
    check: true,
  },
  {
    value: "PHONE OUT",
    label: "PHONE OUT",
    check: true,
  },
  {
    value: "TEXT OUT",
    label: "TEXT OUT",
    check: true,
  },
  {
    value: "EMAIL IN",
    label: "EMAIL IN",
    check: true,
  },
  {
    value: "PHONE IN",
    label: "PHONE IN",
    check: true,
  },
  {
    value: "TEXT IN",
    label: "TEXT IN",
    check: true,
  },
  {
    value: "MEETING - LIVE",
    label: "MEETING - LIVE",
    check: true,
  },
  {
    value: "MEETING - VIRTUAL",
    label: "MEETING - VIRTUAL",
    check: true,
  },
  {
    value: "Lead: Zillow",
    label: "Lead: Zillow",
    check: true,
  },
  {
    value: "Lead: Sierra Interactive",
    label: "Lead: Sierra Interactive",
    check: true,
  },
];

export const TABSSIDE = [
  {
    value: "timeline",
    label: "Timeline",
  },
  {
    value: "tasks",
    label: "Tasks",
  },
  {
    value: "notes",
    label: "Notes",
  },
];

export const Status_Type = [
  {
    value: "true",
    label: "Completed",
  },
  {
    value: "false",
    label: "Open",
  },
];

export const All_Opportunities_List = [
  {
    value: "sell",
    label: "Sell",
  },
  {
    value: "buy",
    label: "Buy",
  },
];

export const Stage_data = [
  {
    value: "close",
    label: "Closed",
  },
  {
    value: "watch",
    label: "Watch",
  },
  {
    value: "open",
    label: "Open",
  },
];

export const buyingData = [
  {
    showingName: "Max Budget",
    fieldnName: "max_budget",
  },
  {
    showingName: "SQ. Feet",
    fieldnName: "square_feet",
  },
  {
    showingName: "Timeframe",
    fieldnName: "timeframe",
  },
  {
    showingName: "Finance Type",
    fieldnName: "finance_type",
  },
  {
    showingName: "Bedrooms",
    fieldnName: "bedrooms",
  },
  {
    showingName: "Ideal Move In Date",
    fieldnName: "ideal_move_in_date",
  },
  {
    showingName: "Down Pay. Amount",
    fieldnName: "down_pay_amount",
  },
  {
    showingName: "Bathrooms",
    fieldnName: "bathrooms",
  },
  {
    showingName: "Next Follow Up",
    fieldnName: "next_follow_up",
  },
];

export const sellingData = [
  {
    showingName: "List Price Estimate",
    fieldnName: "list_price_estimate",
  },
  {
    showingName: "SQ. Feet",
    fieldnName: "square_feet",
  },
  {
    showingName: "Timeframe To List",
    fieldnName: "timeframe_to_list",
  },
  {
    showingName: "Cma Value Low",
    fieldnName: "cma_value_low",
  },
  {
    showingName: "Bedrooms",
    fieldnName: "bedrooms",
  },
  {
    showingName: "Ideal Move In Date",
    fieldnName: "ideal_move_in_date",
  },
  {
    showingName: "Cma Value High",
    fieldnName: "cma_value_high",
  },
  {
    showingName: "Bathrooms",
    fieldnName: "bathrooms",
  },
  {
    showingName: "Next Follow Up",
    fieldnName: "next_follow_up",
  },
];

export const leaseRenterData = [
  {
    showingName: "Ideal Payment",
    fieldnName: "ideal_payment",
  },
  {
    showingName: "SQ. Feet",
    fieldnName: "square_feet",
  },
  {
    showingName: "Timeframe",
    fieldnName: "timeframe",
  },
  {
    showingName: "Max Payment",
    fieldnName: "max_payment",
  },
  {
    showingName: "Bedrooms",
    fieldnName: "bedrooms",
  },
  {
    showingName: "Ideal Move Out Date",
    fieldnName: "ideal_move_out_date",
  },
  {
    showingName: "Desired Lease Term",
    fieldnName: "desired_lease_term",
  },
  {
    showingName: "Bathrooms",
    fieldnName: "bathrooms",
  },
  {
    showingName: "Next Follow Up",
    fieldnName: "next_follow_up",
  },
];

export const leaseListingData = [
  {
    showingName: "List Price Estimate",
    fieldnName: "list_price_estimate",
  },
  {
    showingName: "SQ. Feet",
    fieldnName: "square_feet",
  },
  {
    showingName: "Timeframe To List",
    fieldnName: "timeframe_to_list",
  },
  {
    showingName: "Rental Rate Estimate Low",
    fieldnName: "rental_rate_estimate_low",
  },
  {
    showingName: "Bedrooms",
    fieldnName: "bedrooms",
  },
  {
    showingName: "Ideal Move Out Date",
    fieldnName: "ideal_move_out_date",
  },
  {
    showingName: "Rental Rate Estimate High",
    fieldnName: "rental_rate_estimate_high",
  },
  {
    showingName: "Bathrooms",
    fieldnName: "bathrooms",
  },
  {
    showingName: "Next Follow Up",
    fieldnName: "next_follow_up",
  },
];

export const cardNavigate = (name) => {
  switch (name) {
    case "OpportunityBuying":
      return "opportunity";
    case "OpportunitySelling":
      return "opportunity";
    case "OpportunityLeaseRenter":
      return "opportunity";
    case "OpportunityLeaseListing":
      return "opportunity";
    case "TransactionBuying":
      return "transaction";
    case "TransactionSelling":
      return "transaction";
    case "TransactionLeaseRenter":
      return "transaction";
    case "TransactionLeaseListing":
      return "transaction";
    case "Refinance":
      return "loan";
    case "Purchase":
      return "loan";
    case "HELOC":
      return "loan";
  }
};

export const cardName = (name) => {
  switch (name) {
    case "OpportunityBuying":
      return "OPPORTUNITY : RE - BUYING";
    case "OpportunitySelling":
      return "OPPORTUNITY : RE - SELLING";
    case "OpportunityLeaseRenter":
      return "OPPORTUNITY : RE - LEASE RENTER";
    case "OpportunityLeaseListing":
      return "OPPORTUNITY : RE - LEASE LISTING";
    case "TransactionBuying":
      return "TRANSACTION : RE - BUYING";
    case "TransactionSelling":
      return "TRANSACTION : RE - SELLING";
    case "TransactionLeaseRenter":
      return "TRANSACTION : RE - LEASE RENTER";
    case "TransactionLeaseListing":
      return "TRANSACTION : RE - LEASE LISTING";
    case "Purchase":
      return "LOAN : PURCHASE";
    case "HELOC":
      return "LOAN : HELOC";
    case "Refinance":
      return "LOAN : REFINANCE";
  }
};

export const setColorCard = (color) => {
  switch (color) {
    case "OpportunityBuying":
      return PRIMARY.orange;
    case "OpportunitySelling":
      return PRIMARY.green;
    case "OpportunityLeaseRenter":
      return PRIMARY.red;
    case "OpportunityLeaseListing":
      return PRIMARY.purple;
    case "TransactionBuying":
      return PRIMARY.orange;
    case "TransactionSelling":
      return PRIMARY.green;
    case "TransactionLeaseRenter":
      return PRIMARY.red;
    case "TransactionLeaseListing":
      return PRIMARY.purple;
    case "Purchase":
      return PRIMARY.mediumBlue;
    case "HELOC":
      return PRIMARY.dodgerBlue;
    case "Refinance":
      return PRIMARY.plum;
  }
};

export const cardBackGroundColor = (color) => {
  switch (color) {
    case "OpportunityBuying":
      return PRIMARY.lightOrange;
    case "OpportunitySelling":
      return PRIMARY.lightGreen;
    case "OpportunityLeaseRenter":
      return PRIMARY.lightRed;
    case "OpportunityLeaseListing":
      return PRIMARY.lightPurple;
    case "TransactionBuying":
      return PRIMARY.lightOrange;
    case "TransactionSelling":
      return PRIMARY.lightGreen;
    case "TransactionLeaseRenter":
      return PRIMARY.lightRed;
    case "TransactionLeaseListing":
      return PRIMARY.lightPurple;
    case "Purchase":
      return PRIMARY.blueLight;
    case "HELOC":
      return PRIMARY.shadesBlue;
    case "Refinance":
      return PRIMARY.plumlight;
  }
};

export const cardIcon = (color) => {
  switch (color) {
    case "OpportunityBuying":
      return <img src={buying} />;
    case "OpportunitySelling":
      return <img src={selling} />;
    case "OpportunityLeaseRenter":
      return <img src={renter} />;
    case "OpportunityLeaseListing":
      return <img src={listing} />;
    case "TransactionBuying":
      return <img src={buying} />;
    case "TransactionSelling":
      return <img src={selling} />;
    case "TransactionLeaseRenter":
      return <img src={renter} />;
    case "TransactionLeaseListing":
      return <img src={listing} />;
    case "Purchase":
      return <img src={purching} />;
    case "HELOC":
      return <img src={heloc} />;
    case "Refinance":
      return <img src={refinance} />;
  }
};

export const cardOppBuyingData = [
  {
    fieldsName: "Max Budget",
    value: "max_budget",
    type: "currency",
  },
  {
    fieldsName: "Square Feet",
    value: "square_feet",
    type: "number",
  },
  {
    fieldsName: "Timeframe",
    value: "timeframe",
    type: "text",
  },
  {
    fieldsName: "Finance Type",
    value: "financing_type",
    type: "text",
  },
  {
    fieldsName: "Bedrooms",
    value: "bedrooms",
    type: "number",
  },
  {
    fieldsName: "Ideal Move In Date",
    value: "ideal_move_in_date",
    type: "date",
  },
  {
    fieldsName: "Down Pay. Amount",
    value: "down_payment_amount",
    type: "currency",
  },
  {
    fieldsName: "Bathrooms",
    value: "bathrooms",
    type: "number",
  },
  {
    fieldsName: "Next Follow Up",
    value: "",
  },
];

export const cardOppSellingdata = [
  {
    fieldsName: "List Price Estimate",
    value: "list_price_estimate",
    type: "currency",
  },
  {
    fieldsName: "Square Feet",
    value: "subject_square_feet",
    type: "number",
  },
  {
    fieldsName: "Timeframe To List",
    value: "timeframe_to_list",
    type: "text",
  },
  {
    fieldsName: "CMA Value Low",
    value: "subject_cma_value_low",
    type: "number",
  },
  {
    fieldsName: "Bedrooms",
    value: "subject_bedrooms",
    type: "text",
  },
  {
    fieldsName: "Ideal Move Out Date",
    value: "ideal_move_out_date",
    type: "date",
  },
  {
    fieldsName: "CMA Value High",
    value: "subject_cma_value_high",
    type: "number",
  },
  {
    fieldsName: "Bathrooms",
    value: "subject_bathrooms",
    type: "text",
  },
  {
    fieldsName: "Next Follow Up",
    value: "",
  },
];

export const cardOppLeaseRenterData = [
  {
    fieldsName: "Ideal Payment",
    value: "ideal_payment",
    type: "currency",
  },
  {
    fieldsName: "Square Feet",
    value: "square_feet",
    type: "number",
  },
  {
    fieldsName: "Timeframe",
    value: "timeframe",
    type: "text",
  },
  {
    fieldsName: "Max Payment",
    value: "max_payment",
    type: "currency",
  },
  {
    fieldsName: "Bedrooms",
    value: "bedrooms",
  },
  {
    fieldsName: "Ideal Move In Date",
    value: "ideal_move_in_date",
    type: "date",
  },
  {
    fieldsName: "Desired Lease Term",
    value: "desired_lease_term",
    type: "text",
  },
  {
    fieldsName: "Bathrooms",
    value: "bathrooms",
    // type: "number",
  },
  {
    fieldsName: "Next Follow Up",
    value: "",
  },
];

export const cardOppLeaseListingData = [
  {
    fieldsName: "List Price Estimate",
    value: "list_price_estimate",
    type: "currency",
  },
  {
    fieldsName: "Square Feet",
    value: "subject_square_feet",
    type: "currency",
  },
  {
    fieldsName: "Timeframe To List",
    value: "timeframe_to_list",
    type: "text",
  },
  {
    fieldsName: "Rental Rate Estimate Low",
    value: "rental_rate_estimate_low",
    type: "text",
  },
  {
    fieldsName: "Bedrooms",
    value: "subject_bedrooms",
    type: "number",
  },
  {
    fieldsName: "Ideal Move Out Date",
    value: "ideal_move_out_date",
    type: "date",
  },
  {
    fieldsName: "Rental Rate Estimate High",
    value: "rental_rate_estimate_high",
    type: "text",
  },
  {
    fieldsName: "Bathrooms",
    value: "subject_bathrooms",
    type: "number",
  },
  {
    fieldsName: "Next Follow Up",
    value: "",
  },
];

export const cardTraBuyingData = [
  {
    fieldsName: "Sale Price",
    value: "sale_price",
    type: "currency",
  },
  {
    fieldsName: "Under Contract Date",
    value: "under_contract_date",
    type: "date",
  },
  {
    fieldsName: "Contract Close Date",
    value: "close_date",
    type: "date",
  },
  {
    fieldsName: "Occupancy Rate",
    value: "occupancy_rate",
    type: "text",
  },
  {
    fieldsName: "Occupancy Days Allowed",
    value: "occupancy_days_allowed",
    type: "text",
  },
  {
    fieldsName: "Occupancy End Date",
    value: "occupancy_end_date",
    type: "date",
  },
  {
    fieldsName: "Inspection Status",
    value: "inspection_status",
    type: "text",
  },
  {
    fieldsName: "Appraisal Status",
    value: "appraisal_status",
    type: "text",
  },
  {
    fieldsName: "Loan Status",
    value: "loan_status",
    type: "text",
  },
];

export const cardTraSellingData = [
  {
    fieldsName: "Sale Price",
    value: "sale_price",
    type: "currency",
  },
  {
    fieldsName: "Under Contract Date",
    value: "under_contract_date",
    type: "date",
  },
  {
    fieldsName: "Contract Close Date",
    value: "contract_close_date",
    type: "date",
  },
  {
    fieldsName: "Occupancy Rate",
    value: "occupancy_rate",
    type: "text",
  },
  {
    fieldsName: "Occupancy Days Allowed",
    value: "occupancy_days_allowed",
    type: "text",
  },
  {
    fieldsName: "Occupancy End Date",
    value: "occupancy_end_date",
    type: "date",
  },
  {
    fieldsName: "Inpsection Status",
    value: "inspection_status",
    type: "text",
  },
  {
    fieldsName: "Appraisal Status",
    value: "appraisal_status",
    type: "text",
  },
  {
    fieldsName: "Loan Status",
    value: "loan_status",
    type: "text",
  },
];

export const cardTraLeaseListingData = [
  {
    fieldsName: "Lease Term",
    value: "lease_term",
    type: "text",
  },
  {
    fieldsName: "Rent (Mo)",
    value: "rent_mo",
    type: "currency",
  },
  {
    fieldsName: "Security Deposit",
    value: "security_deposit_doallar",
    type: "currency",
  },
  {
    fieldsName: "Lease Signing Date",
    value: "lease_signed_date",
    type: "date",
  },
  {
    fieldsName: "Lease Start Date",
    value: "lease_start_date",
    type: "date",
  },
  {
    fieldsName: "Lease Expiration Date",
    value: "lease_expiration_date",
    type: "date",
  },
];

export const cardTraLeaseRenterData = [
  {
    fieldsName: "Lease Term",
    value: "lease_term",
    type: "text",
  },
  {
    fieldsName: "Rent (Mo)",
    value: "rent_mo",
    type: "currency",
  },
  {
    fieldsName: "Security Deposit",
    value: "security_deposit",
    type: "currency",
  },
  {
    fieldsName: "Lease Signing Date",
    value: "lease_signing_date",
    type: "date",
  },
  {
    fieldsName: "Lease Start Date",
    value: "lease_start_date",
    type: "date",
  },
  {
    fieldsName: "Lease Expiration Date",
    value: "lease_expiration_date",
    type: "date",
  },
];

export const assignmentOptions = [
  {
    value: "contact",
    label: "Contact",
  },
  {
    value: "role",
    label: "Role",
  },
  {
    value: "user",
    label: "User",
  },
];

export const assignmentOptionsForCreateTask = [
  {
    value: "contact",
    label: "Contact",
  },
  {
    value: "user",
    label: "User",
  },
];

export const phaseFilter = (data) => {
  switch (data) {
    case "opportunitybuying":
      return "opportunityBuying";
    case "opportunityselling":
      return "opportunitySelling";
    case "opportunityleaserenter":
      return "opportunityLeaseRenter";
    case "opportunityleaselisting":
      return "opportunityLeaseListing";
    case "transactionbuying":
      return "transactionBuying";
    case "transactionselling":
      return "transactionSelling";
    case "transactionleaserenter":
      return "transactionLeaseRenter";
    case "transactionleaselisting":
      return "transactionLeaseListing";
    default:
      break;
  }
};

export const allTypeOfCardOptions = [
  {
    value: "lead",
    label: "Contact",
    type: "contact",
  },
  {
    value: "opportunityBuying",
    label: "Real Estate Buying",
    type: "Re_user",
  },
  {
    value: "opportunitySelling",
    label: "Real Estate Selling",
    type: "Re_user",
  },
  {
    value: "opportunityLeaseRenter",
    label: "Real Estate Lease Renter",
    type: "Re_user",
  },
  {
    value: "opportunityLeaseListing",
    label: "Real Estate Lease Listing",
    type: "Re_user",
  },
  {
    value: "transactionBuying",
    label: "Transaction Buying",
    type: "Re_user",
  },
  {
    value: "transactionSelling",
    label: "Transaction Selling",
    type: "Re_user",
  },
  {
    value: "transactionLeaseRenter",
    label: "Transaction Lease Renter",
    type: "Re_user",
  },
  {
    value: "transactionLeaseListing",
    label: "Transaction Lease Listing",
    type: "Re_user",
  },
  {
    value: "loanPurchase",
    label: "Loan Purchase",
    type: "loan_user",
  },
  {
    value: "loanRefinance",
    label: "Loan Refinance",
    type: "loan_user",
  },
  {
    value: "loanHeloc",
    label: "Loan HELOC",
    type: "loan_user",
  },
];

export const taskDocOptions = [
  {
    value: "doc",
    label: "Document",
  },
  {
    value: "action",
    label: "Action",
  },
];

export const docOptions = [
  {
    value: "2022 W-2",
    label: "2022 W-2",
  },
  {
    value: "Bank Statement",
    label: "Bank Statement",
  },
  {
    value: "Current Tax Return",
    label: "Current Tax Return",
  },
];

export const USAState = [
  { value: "Alabama", label: "Alabama" },
  { value: "Alaska", label: "Alaska" },
  { value: "Arizona", label: "Arizona" },
  { value: "Arkansas", label: "Arkansas" },
  { value: "California", label: "California" },
  { value: "Colorado", label: "Colorado" },
  { value: "Connecticut", label: "Connecticut" },
  { value: "Delaware", label: "Delaware" },
  { value: "Florida", label: "Florida" },
  { value: "Georgia", label: "Georgia" },
  { value: "Hawaii", label: "Hawaii" },
  { value: "Idaho", label: "Idaho" },
  { value: "Illinois", label: "Illinois" },
  { value: "Indiana", label: "Indiana" },
  { value: "Iowa", label: "Iowa" },
  { value: "Kansas", label: "Kansas" },
  { value: "Kentucky", label: "Kentucky" },
  { value: "Louisiana", label: "Louisiana" },
  { value: "Maine", label: "Maine" },
  { value: "Maryland", label: "Maryland" },
  { value: "Massachusetts", label: "Massachusetts" },
  { value: "Michigan", label: "Michigan" },
  { value: "Minnesota", label: "Minnesota" },
  { value: "Mississippi", label: "Mississippi" },
  { value: "Missouri", label: "Missouri" },
  { value: "Montana", label: "Montana" },
  { value: "Nebraska", label: "Nebraska" },
  { value: "Nevada", label: "Nevada" },
  { value: "Hampshire", label: "Hampshire" },
  { value: "Jersey", label: "Jersey" },
  { value: "Mexico", label: "Mexico" },
  { value: "York", label: "York" },
  { value: "Carolina", label: "Carolina" },
  { value: "Dakota", label: "Dakota" },
  { value: "Ohio", label: "Ohio" },
  { value: "Oklahoma", label: "Oklahoma" },
  { value: "Oregon", label: "Oregon" },
  { value: "Pennsylvania", label: "Pennsylvania" },
  { value: "Island", label: "Island" },
  { value: "Tennessee", label: "Tennessee" },
  { value: "Texas", label: "Texas" },
  { value: "Utah", label: "Utah" },
  { value: "Vermont", label: "Vermont" },
  { value: "Virginia", label: "Virginia" },
  { value: "Washington", label: "Washington" },
  { value: "Wisconsin", label: "Wisconsin" },
  { value: "Wyoming", label: "Wyoming" },
];

export const yes_no_maybe_option = [
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "No",
    label: "No",
  },
  {
    value: "Maybe",
    label: "Maybe",
  },
];

export const leadProviderOptions = [
  {
    value: "Website",
    label: "Website",
  },
  {
    value: "Lending Tree",
    label: "Lending Tree",
  },
  {
    value: "Zillow",
    label: "Zillow",
  },
];

export const creaditScoreOptions = [
  {
    value: "Below 580",
    label: "Below 580",
  },
  {
    value: "580-619",
    label: "580-619",
  },
  {
    value: "620-639",
    label: "620-639",
  },
  {
    value: "640-659",
    label: "640-659",
  },
  {
    value: "660-679",
    label: "660-679",
  },
  {
    value: "680-699",
    label: "680-699",
  },
  {
    value: "700-719",
    label: "700-719",
  },
  {
    value: "720-739",
    label: "720-739",
  },
  {
    value: "Above 740",
    label: "Above 740",
  },
];

export const Yes_no_options = [
  {
    value: true,
    label: "Yes",
  },
  {
    value: false,
    label: "No",
  },
];

export const PropertyTypeOptions = [
  {
    value: "2-4 Unit Family",
    label: "2-4 Unit Family",
  },
  {
    value: "Single Family",
    label: "Single Family",
  },
  {
    value: "Condominium",
    label: "Condominium",
  },
  {
    value: "Tonwnhouse",
    label: "Tonwnhouse",
  },
];

export const PropertyUseOptions = [
  {
    value: "Primary",
    label: "Primary",
  },
  {
    value: "Secondary",
    label: "Secondary",
  },
  {
    value: "Investment",
    label: "Investment",
  },
];

export const LoanPurposeOptions = [
  {
    value: "PURCHASE",
    label: "PURCHASE",
  },
  {
    value: "REFI - CASHOUT",
    label: "REFI - CASHOUT",
  },
  {
    value: "REFI-RATE/TERM",
    label: "REFI-RATE/TERM",
  },
];

export const LoanTypeOptions = [
  {
    value: "Purchase",
    label: "Purchase",
  },
  {
    value: "Refinance",
    label: "Refinance",
  },
];

export const LoanCreateOptions = [
  {
    value: "Purchase",
    label: "Purchase",
  },
  {
    value: "Refinance",
    label: "Refinance",
  },
  {
    value: "HELOC",
    label: "HELOC",
  },
];

export const EstimatedLoanTypeOptions = [
  {
    value: "Conventional",
    label: "Conventional",
  },
  {
    value: "FHA",
    label: "FHA",
  },
  {
    value: "VA",
    label: "VA",
  },
  {
    value: "USDA",
    label: "USDA",
  },
  {
    value: "FHA 203K",
    label: "FHA 203K",
  },
  {
    value: "Non-QM",
    label: "Non-QM",
  },
];

export const topPriorityOptions = [
  {
    value: "Payment",
    label: "Payment",
  },
  {
    value: "Cash To Close",
    label: "Cash To Close",
  },
  {
    value: "Cash Out",
    label: "Cash Out",
  },
  {
    value: "Debt Paid",
    label: "Debt Paid",
  },
  {
    value: "Lower Payment",
    label: "Lower Payment",
  },
  {
    value: "Interest Rate",
    label: "Interest Rate",
  },
];

export const assetsOptions = [
  {
    value: "Not Provided",
    label: "Not Provided",
  },
  {
    value: "Verbal",
    label: "Verbal",
  },
  {
    value: "Validated",
    label: "Validated",
  },
];

export const CompensationTypeOptions = [
  {
    value: "LENDER PAID",
    label: "LENDER PAID",
  },
  {
    value: "BORROWER PAID",
    label: "BORROWER PAID",
  },
];

export const AppraisalStatusOptions = [
  {
    value: "Ordered",
    label: "Ordered",
  },
  {
    value: "Scheduled",
    label: "Scheduled",
  },
  {
    value: "In At Value",
    label: "In At Value",
  },
  {
    value: "In with Repairs",
    label: "In with Repairs",
  },
  {
    value: "In Below Value",
    label: "In Below Value",
  },
  {
    value: "Cleared",
    label: "Cleared",
  },
];

export const TitleStatusOptions = [
  {
    value: "Requested",
    label: "Requested",
  },
  {
    value: "Received",
    label: "Received",
  },
  {
    value: "Submitted",
    label: "Submitted",
  },
  {
    value: "Cleared",
    label: "Cleared",
  },
];

export const InitialCDOptions = [
  {
    value: "Requested",
    label: "Requested",
  },
  {
    value: "Received",
    label: "Received",
  },
  {
    value: "Sent for Signing",
    label: "Sent for Signing",
  },
  {
    value: "Signed",
    label: "Signed",
  },
];

export const lenderOptions = [
  {
    value: "UWM",
    label: "UWM",
  },
  {
    value: "Rocket",
    label: "Rocket",
  },
  {
    value: "Newrez",
    label: "Newrez",
  },
  {
    value: "Orion",
    label: "Orion",
  },
  {
    value: "Franklin",
    label: "Franklin",
  },
  {
    value: "The Loan Store",
    label: "The Loan Store",
  },
  {
    value: "Power TPO",
    label: "Power TPO",
  },
  {
    value: "Nations Direct",
    label: "Nations Direct",
  },
  {
    value: "NEXBANK",
    label: "NEXBANK",
  },
  {
    value: "RCN Capital",
    label: "RCN Capital",
  },
  {
    value: "Citizens",
    label: "Citizens",
  },
  {
    value: "JMAC",
    label: "JMAC",
  },
  {
    value: "REMN",
    label: "REMN",
  },
  {
    value: "Flagstar",
    label: "Flagstar",
  },
  {
    value: "Provident Funding",
    label: "Provident Funding",
  },
  {
    value: "PRMG",
    label: "PRMG",
  },
  {
    value: "HomeXpress",
    label: "HomeXpress",
  },
  {
    value: "Windsor",
    label: "Windsor",
  },
  {
    value: "Angel Oak",
    label: "Angel Oak",
  },
];

export const usStateCodes = [
  { value: "AK", label: "AK" }, // Alaska
  { value: "AZ", label: "AZ" }, // Arizona
  { value: "AR", label: "AR" }, // Arkansas
  { value: "CA", label: "CA" }, // California
  { value: "CO", label: "CO" }, // Colorado
  { value: "CT", label: "CT" }, // Connecticut
  { value: "DE", label: "DE" }, // Delaware
  { value: "FL", label: "FL" }, // Florida
  { value: "GA", label: "GA" }, // Georgia
  { value: "HI", label: "HI" }, // Hawaii
  { value: "ID", label: "ID" }, // Idaho
  { value: "IL", label: "IL" }, // Illinois
  { value: "IN", label: "IN" }, // Indiana
  { value: "IA", label: "IA" }, // Iowa
  { value: "KS", label: "KS" }, // Kansas
  { value: "KY", label: "KY" }, // Kentucky
  { value: "LA", label: "LA" }, // Louisiana
  { value: "ME", label: "ME" }, // Maine
  { value: "MD", label: "MD" }, // Maryland
  { value: "MA", label: "MA" }, // Massachusetts
  { value: "MI", label: "MI" }, // Michigan
  { value: "MN", label: "MN" }, // Minnesota
  { value: "MS", label: "MS" }, // Mississippi
  { value: "MO", label: "MO" }, // Missouri
  { value: "MT", label: "MT" }, // Montana
  { value: "NE", label: "NE" }, // Nebraska
  { value: "NV", label: "NV" }, // Nevada
  { value: "NH", label: "NH" }, // New Hampshire
  { value: "NJ", label: "NJ" }, // New Jersey
  { value: "NM", label: "NM" }, // New Mexico
  { value: "NY", label: "NY" }, // New York
  { value: "NC", label: "NC" }, // North Carolina
  { value: "ND", label: "ND" }, // North Dakota
  { value: "OH", label: "OH" }, // Ohio
  { value: "OK", label: "OK" }, // Oklahoma
  { value: "OR", label: "OR" }, // Oregon
  { value: "PA", label: "PA" }, // Pennsylvania
  { value: "RI", label: "RI" }, // Rhode Island
  { value: "SC", label: "SC" }, // South Carolina
  { value: "SD", label: "SD" }, // South Dakota
  { value: "TN", label: "TN" }, // Tennessee
  { value: "TX", label: "TX" }, // Texas
  { value: "UT", label: "UT" }, // Utah
  { value: "VT", label: "VT" }, // Vermont
  { value: "VA", label: "VA" }, // Virginia
  { value: "WA", label: "WA" }, // Washington
  { value: "WV", label: "WV" }, // West Virginia
  { value: "WI", label: "WI" }, // Wisconsin
  { value: "WY", label: "WY" }, // Wyoming
];
